import React from 'react';
import classNames from 'classnames';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../context/api-context/use-api';
import styles from './text-extended.module.scss';
const TextExtended = (props) => (React.createElement(TextExtendedNoUseApi, { ...props, mobile: useApi(getIsMobile) }));
// Extracted for error boundary fallback
export const TextExtendedNoUseApi = ({ className, priority = 'primary', typography = 'content', dataHook, mobile, size, tag, ...props }) => {
    const Component = (tag ?? 'span');
    return (React.createElement(Component, { className: classNames(styles.root, styles[`priority-${priority}`], styles[`typography-${typography}`], mobile && styles.mobile, styles[`size-${size || typography}`], className), "data-hook": dataHook, ...props }));
};
export default TextExtended;
//# sourceMappingURL=text-extended.js.map